export const SET_ITEMS = (state, payload) => {
  state.items = payload;
};
